import { FormattedMessage } from 'react-intl';
import { ReactElement, useEffect, useRef } from 'react';
import { SnackbarContentCallback, SnackbarKey, useSnackbar } from 'notistack';

import { BlendDown } from '../blend-down/blend-down';
import { ErrorSnackbar } from './components/error-snackbar';
import { FatalErrorSnackbar } from './components/fatal-error-snackbar';
import { PoolSnackbarType } from './pool-snackbar';
import { SuccessSnackbar } from './components/success-snackbar';
import { removeSnackbar } from '../../store/snackbar-actions';
import { useAppDispatch, useAppSelector } from '../../../store/store';

const contentCallbackMap: { [Key in PoolSnackbarType]: SnackbarContentCallback | undefined } = {
    success: (key, message) => <SuccessSnackbar key={key} message={message} />,
    error: (key, message) => <ErrorSnackbar key={key} message={message} />,
    fatal: (key, message) => <FatalErrorSnackbar key={key} message={message} />,
};

export const SnackbarNotifier = (): ReactElement | null => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useAppDispatch();
    const notifications = useAppSelector(state => state.snackbar.notifications);

    const displayed = useRef<SnackbarKey[]>([]);
    const maxStoreItems = 20;

    const storeDisplayed = (key: SnackbarKey): void => {
        displayed.current = [...displayed.current.slice(-maxStoreItems), key];
    };

    useEffect(() => {
        notifications.forEach(notification => {
            if (displayed.current.includes(notification.key)) {
                return;
            }

            enqueueSnackbar(<FormattedMessage id={notification.message} values={notification.values} />, {
                ...notification.options,
                key: notification.key,
                content: contentCallbackMap[notification.notificationType],
            });
            storeDisplayed(notification.key);
            dispatch(removeSnackbar(notification.key));
        });
    }, [dispatch, enqueueSnackbar, notifications]);

    return displayed.current.includes('fatal') ? <BlendDown open={true} /> : null;
};
